import Button from "../../../../common/button";
import TransactionsStyleWrapper from "./Transactions.style";
import transactionImg from "../../../../assets/images/services/services-img.jpg";

const Transactions = () => {
  return (
    <TransactionsStyleWrapper>
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="about_right_content">
              <img src={transactionImg} alt="transaction" />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="transaction_right_content">
              <p className="transaction_tag">TRANSACTIONS</p>
              <h2 className="transaction_title">
                BLOCKCHAIN WILL RECORD <br /> All Transactions
              </h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et dolore magna aliqua. enim ad minim veniam, quis exercitation ullamco laboris nisi ut aliquip ex.
              </p>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et dolore magna aliqua. enim ad minim veniam, quis exercitation ullamco laboris nisi ut aliquip ex.
              </p>

              <Button lg variant="outline" className="contact_btn">
                Contact Us
              </Button>
            </div>
          </div>
        </div>
      </div>
    </TransactionsStyleWrapper>
  );
};

export default Transactions;
